import { RelevancyFeedback } from './relevancy-feedback.model';

export const LER_SUPPORTED_REGIONS = {
  au: { name: 'Australia' },
  at: { name: 'Austria' },
  br: { name: 'Brazil' },
  ca: { name: 'Canada' },
  fr: { name: 'France' },
  de: { name: 'Germany' },
  in: { name: 'India' },
  it: { name: 'Italy' },
  nl: { name: 'Netherlands' },
  nz: { name: 'New Zealand' },
  pl: { name: 'Poland' },
  sg: { name: 'Singapore' },
  za: { name: 'South Africa' },
  gb: { name: 'United Kingdom' },
  us: { name: 'United States' },
};

export type JobRolePreferenceStatus = 'relevant' | 'neutral' | 'irrelevant';

export interface JobRolePreference {
  id: string;
  job_title: { id: number; name: string };
  status: JobRolePreferenceStatus;
}

export interface JobInsightSalaryRange {
  min: number | null;
  max: number | null;
  currency: string;
}

export interface SalaryDistributionItem {
  average_salary: number;
  percentage: number;
}

export interface JobInsight {
  id: number;
  job_role: string;
  salary_range: {
    min: number;
    max: number;
    currency: string;
  };
  salary_distribution?: SalaryDistributionItem[];
  job_role_preference: JobRolePreference | null;
  jobs_link: string;
  employers?: {
    count: number;
    top: Array<{
      name: string;
      jobs_link: string;
    }>;
  };
  relevancy_feedback?: RelevancyFeedback;
}
